import type { GeofenceState } from './reducer';
import { compose } from 'redux';

import { mapWebData } from '@cobliteam/api-lib';

import type { AppState } from '../AppState';

export const selectGeofencesDomain = (state: AppState): GeofenceState => state.geofences;

export const selectGeofences = compose((state) => state.geofencesWebData, selectGeofencesDomain);

const selectImportCreationWebData = compose((state) => state.validateGeofencesWebData, selectGeofencesDomain);

export const selectValidAddresses = compose(
  mapWebData((data) => data.valid),
  selectImportCreationWebData
);

export const selectInvalidAddresses = compose(
  mapWebData((data) => data.invalid),
  selectImportCreationWebData
);

export const selectImportId = compose(
  mapWebData((data) => data.import_id),
  selectImportCreationWebData
);

export const selectImportConfirmationWebData = compose((state) => state.importGeofencesWebData, selectGeofencesDomain);
